import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/subpage/test-1.png';
import _imports_1 from '@/assets/image/subpage/test-2.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-fa8df830"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "wrap"
};
var _hoisted_2 = {
  class: "inner"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("推动行业标准建立者");

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "details"
  }, " 2019年2月，核桃编程成为全国青少年软件编程等级考试的首席战略合作伙伴，并与北京大学、南开大学、浙江大学、重庆大学、腾讯公司、微软公司等众多高校和机构共同构建了等级考试标准体系。核桃编程创始人兼CEO曾鹏轩、联合创始人兼CTO王宇航受邀成为《全国青少年软件编程等级考试标准》标准工作组专家。 ", -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    srcset: ""
  }, null, -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    srcset: ""
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ModuleTitle = _resolveComponent("ModuleTitle");

  var _component_a_col = _resolveComponent("a-col");

  var _component_a_row = _resolveComponent("a-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ModuleTitle, {
    class: "module-title"
  }, {
    default: _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }), _hoisted_4, _createVNode(_component_a_row, {
    gutter: 20,
    class: "img-list"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 12
      }, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 12
      }, {
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]);
}